import React from 'react'
import { CheckIcon } from '@heroicons/react/outline'


function EnterpriseToken() {
    return (
        <div className="bg-white shadow-md p-4 rounded-md flex">
        <div>
            <p className="mt-2">
                <span className="text-2xl font-bold text-gray-700">Enterprise Plan</span>
            </p>
            <div className='flex my-4'>
                <div>
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/><b>Greater Than 2500 Messages Monthly</b></p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Team Seats</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Saved Messages</p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> 24/7 Boundie Hunter Support</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Exclusive Access to New Releases</p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> Rollover on Tokens</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Prospect Searches</p>
                    {/* <p className='flex my-2'><CheckIcon className="text-green-400 h-5 mr-2"/> Rollover on Tokens</p> */}
                </div>
            </div>
        </div>
        <div className="ml-auto mr-2 mt-2">
            <div>
                <p>
                    <span className="text-2xl">Contact Team</span>
                </p>
                {/* <button
                className="px-4 py-1 rounded-md bg-green-500 text-white hover:bg-green-700 font-semibold mt-3"
                >
                    Contact tyllen@boundsales.com for
                </button> */}
            </div>
        </div>
    </div>
    )
}

export default EnterpriseToken
